import { useState } from "react";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    window.alert("正在搜索「" + keyword.trim() + "」相关高甜内容…");
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20dreamy%20pastel%20background%20with%20floating%20pink%20and%20coral%20cotton%20candy%20clouds%20and%20sparkles%20and%20delicate%20sugar%20particles%2C%20warm%20cream%20and%20blush%20tones%2C%20abstract%20sweet%20dream%20aesthetic%2C%20gentle%20gradient%2C%20airy%20and%20light%2C%20wide%20cinematic%20scene&width=1800&height=1200&seq=hero-bg-candy&orientation=landscape"
          alt="甜系梦幻棉花糖云朵背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col items-center px-4 pb-16 pt-32 text-center md:px-6 md:pb-24 md:pt-44">
        <div className="mb-6 flex items-center gap-2 rounded-full border border-primary-200 bg-white/80 px-4 py-1.5 text-xs text-primary-700">
          <i className="ri-flashlight-fill text-sm text-accent-500"></i>
          今日糖分补给 · 高甜瓜料持续更新
        </div>

        <h1 className="max-w-4xl font-display text-5xl leading-tight text-foreground-950 md:text-7xl md:leading-tight">
          高甜瓜料<span className="text-primary-500">与</span>甜蜜爆料
        </h1>
        <p className="mt-2 font-display text-2xl text-accent-600 md:text-3xl">糖分超标 · 甜到齁</p>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
          吃瓜糖心汇集全网高能甜料与甜到齁的瞬间，每一口都是快乐炸弹。点开就能收获今日份糖分补给，轻松吃到停不下来。
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {["# 高甜CP", "# 甜蜜爆料", "# 甜到齁", "# 治愈小故事"].map((t) => (
            <span
              key={t}
              className="cursor-pointer rounded-full bg-secondary-100/90 px-4 py-1.5 text-sm text-secondary-800 transition-colors hover:bg-secondary-200"
            >
              {t}
            </span>
          ))}
        </div>

        <form
          onSubmit={handleSearch}
          className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:bg-white/90 sm:p-1.5 sm:shadow-[0_2px_16px_0_oklch(var(--primary-500)/0.12)]"
        >
          <div className="flex flex-1 items-center gap-2 rounded-full bg-white px-5 py-3 sm:bg-transparent sm:py-2">
            <i className="ri-search-line text-lg text-secondary-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜一搜今天想看的高甜瓜料…"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap cursor-pointer rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600 sm:py-2.5"
          >
            开启吃瓜
          </button>
        </form>

        <div className="mt-10 grid w-full max-w-3xl grid-cols-3 gap-3 md:grid-cols-3">
          {[
            { num: "1200+", label: "高甜瓜料" },
            { num: "360万+", label: "次甜蜜分享" },
            { num: "7×24", label: "糖分随时供应" },
          ].map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-200 bg-white/80 px-3 py-4 md:py-5">
              <div className="font-display text-2xl text-primary-500 md:text-4xl">{s.num}</div>
              <div className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}